<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <span class="text-blue-400 items-center justify-center fas fa-route">
                </span>
            </div>
        </template>
        <div v-if="!waitingForCode">
            <ui-input label="Email address/phone number" v-model="address"
                      placeholder="Email address/phone number..."
                      class="xl:col-span-12"
                      @input="error = false"
                      @focus=""
                      :disabled="busy"
                      :read-only="busy"
            ></ui-input>
            <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="error" v-text="error"></div>
        </div>
        <div v-if="waitingForCode">
            <div class="mt-2">
                We have sent a 4 digit token to <b>{{ address }}</b>
            </div>
            <div class="text-sm mt-1">This token is active for 5 minutes</div>
            <div class="flex justify-center mt-2">
                <div class="flex-1 justify-center flex">
                    <input type="text" autocomplete="one-time-code" id="topt" name="topt" pattern="\w{4}" v-if="false"
                           required
                           class="mx-2">
                    <div class="w-24 mr-1"><input type="text" id="t1" name="t1" value="" ref="t1" placeholder=""
                                                  @focus="(e) => e.target.select()"
                                                  v-model="t1" @input="t1Changed"
                                                  class="inline-block text-center text-2xl digit rounded border border-gray-300">
                    </div>
                    <div class="w-24 mx-1"><input type="text" id="t2" name="t2" value="" ref="t2" placeholder=""
                                                  @focus="(e) => e.target.select()"
                                                  v-model="t2" @input="t2Changed"
                                                  class="inline-block text-center text-2xl digit rounded border border-gray-300">
                    </div>
                    <div class="w-24 mx-1"><input type="text" id="t3" name="t3" value="" ref="t3" placeholder=""
                                                  @focus="(e) => e.target.select()"
                                                  v-model="t3" @input="t3Changed"
                                                  class="inline-block text-center text-2xl digit rounded border border-gray-300">
                    </div>
                    <div class="w-24 ml-1"><input type="text" id="t4" name="t4" value="" ref="t4" placeholder=""
                                                  @focus="(e) => e.target.select()"
                                                  v-model="t4" @input="t4Changed"
                                                  class="inline-block text-center text-2xl digit rounded border border-gray-300">
                    </div>
                </div>
            </div>
            <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="error" v-text="error"></div>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="busy" @click="request"
                               v-if="!waitingForCode"
                               v-text="button"></ui-button-new>
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="!valid" @click="validate"
                               v-if="waitingForCode"
                               v-text="'Add to Account'"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../ui/UiInput.vue";
import PackageContactSearch from "../contacts/PackageContactSearch.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import {uuid} from "../../utils";
import UiTextarea from "../ui/UiTextarea.vue";

export default {
    components: {UiTextarea, UiButtonNew, PackageContactSearch, UiInput},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: ''
        },
        button: {
            type: String,
            default: ''
        },
        name: '',
        value: null,
        goValidate: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            address: '',
            busy: false,
            error: false,
            valid: false,
            waitingForCode: false,
            t1: '',
            t2: '',
            t3: '',
            t4: '',
        }
    },
    methods: {
        t1Changed() {
            let o = this.t1.replace(/\s/g, "").toUpperCase()
            let focus = false
            if (o.length >= 4) {
                this.t4 = o.slice(3, 4)
                focus = focus ? focus : this.$refs.t4
            }
            if (o.length >= 3) {
                this.t3 = o.slice(2, 3)
                focus = focus ? focus : this.$refs.t4
            }
            if (o.length >= 2) {
                this.t2 = o.slice(1, 2)
                focus = focus ? focus : this.$refs.t3
            }
            if (o.length >= 1) {
                this.t1 = o.slice(0, 1)
                focus = focus ? focus : this.$refs.t2
            }
            if (focus) {
                focus.focus()
            }
            this.checkComplete()
        },
        t2Changed() {
            let o = this.t2.replace(/\s/g, "").toUpperCase()
            let focus = false
            if (o.length >= 3) {
                this.t4 = o.slice(2, 3)
                focus = focus ? focus : this.$refs.t4
            }
            if (o.length >= 2) {
                this.t3 = o.slice(1, 2)
                focus = focus ? focus : this.$refs.t4
            }
            if (o.length >= 1) {
                this.t2 = o.slice(0, 1)
                focus = focus ? focus : this.$refs.t3
            }
            if (focus) {
                focus.focus()
            }
            this.checkComplete()
        },
        t3Changed() {
            let o = this.t3.replace(/\s/g, "").toUpperCase()
            let focus = false
            if (o.length >= 2) {
                this.t4 = o.slice(1, 2)
                focus = focus ? focus : this.$refs.t4
            }
            if (o.length >= 1) {
                this.t3 = o.slice(0, 1)
                focus = focus ? focus : this.$refs.t4
            }
            if (focus) {
                focus.focus()
            }
            this.checkComplete()
        },
        t4Changed() {
            let o = this.t4.replace(/\s/g, "").toUpperCase()
            if (o.length >= 1) {
                this.t4 = o.slice(0, 1)
            }
            this.checkComplete()
        },
        checkComplete() {
            this.valid = this.t1 && this.t2 && this.t3 && this.t4
        },
        async request() {
            this.busy = true;
            this.error = false;
            let id = uuid();
            try {
                await Http.post(route('api.v2.organization.user.handle-request.create', [this.address]))
                this.waitingForCode = true;
            } catch (error) {
                let body = JSON.parse(error.request.response);
                this.error = body.message
            }
            this.busy = false;
        },
        async validate() {
            let token = this.t1 + this.t2 + this.t3 + this.t4;
            this.busy = true;
            this.error = false;
            try {
                await Http.put(route('api.v2.organization.user.handle-request.validate', [this.address]), {'token': token})
                this.handle(this,this)
            } catch (error) {
                let body = JSON.parse(error.request.response);
                this.error = body.message
            }
        }
    },
    mounted() {
        if (this.value) {
            this.address = this.value;
        }
        if (this.goValidate) {
            this.waitingForCode = true;
        }
    }
}
</script>
